{
  "*Partial comparison. Current time period is ongoing.": "*Partial comparison. Current time period is ongoing.",
  "<0>{{formattedValue}}</0> {{label}}": "<0>{{formattedValue}}</0> {{label}}",
  "<0>{{rate}}%</0> {{label}} Rate": "<0>{{rate}}%</0> {{label}} Rate",
  "<0>{{scheduledRate}}%</0> {{label}} Rate": "<0>{{scheduledRate}}%</0> {{label}} Rate",
  "Call Intelligence: Conversion During Call": "Call Intelligence: Conversion During Call",
  "Call Intelligence: Unhappy Calls": "Call Intelligence: Unhappy Calls",
  "Call Intelligence: Unscheduled": "Call Intelligence: Unscheduled",
  "Calls": "Calls",
  "Click the segment to learn more": "Click the segment to learn more",
  "Down {{count}}% since Last {{timePeriod}}._one": "Down {{count}}% since Last {{timePeriod}}.",
  "Down {{count}}% since Last {{timePeriod}}._other": "Down {{count}}% since Last {{timePeriod}}.",
  "Month": "Month",
  "No Calls": "No Calls",
  "No Unhappy Calls": "No Unhappy Calls",
  "No Unscheduled Opportunities": "No Unscheduled Opportunities",
  "No change since Last {{timePeriod}}.": "No change since Last {{timePeriod}}.",
  "Out of <1>{{totalUnscheduledCount}}</1> Unscheduled Calls": "Out of <1>{{totalUnscheduledCount}}</1> Unscheduled Calls",
  "Out of {{count}} Opportunities_one": "Out of {{count}} Opportunity",
  "Out of {{count}} Opportunities_other": "Out of {{count}} Opportunities",
  "Out of {{count}} Unscheduled Calls_one": "Out of {{count}} Unscheduled Calls",
  "Out of {{count}} Unscheduled Calls_other": "Out of {{count}} Unscheduled Calls",
  "Scheduled": "Scheduled",
  "Scheduled Rate": "Scheduled Rate",
  "Unhappy Calls": "Unhappy Calls",
  "Unknown": "Unknown",
  "Unscheduled": "Unscheduled",
  "Up {{count}}% since Last {{timePeriod}}._one": "Up {{count}}% since Last {{timePeriod}}.",
  "Up {{count}}% since Last {{timePeriod}}._other": "Up {{count}}% since Last {{timePeriod}}.",
  "Week": "Week",
  "of {{count}} Calls Analyzed_one": "of {{count}} Calls Analyzed",
  "of {{count}} Calls Analyzed_other": "of {{count}} Calls Analyzed",
  "{{count}} Locations_one": "{{count}} Location",
  "{{count}} Locations_other": "{{count}} Locations"
}
